import { DefaultDirections, SortProviderProps, UrlSortProvider, UserAndSiteSettingsContext } from '@tableau/data-catalog-shared';
import * as React from 'react';

import { OrderDirection, TableauUserOrderField } from '../../../../gen-src/queries/globalTypes';

export type OwnersValidSortFields = TableauUserOrderField.NAME | TableauUserOrderField.ID;

export const OwnersDefaultDirections: DefaultDirections<OwnersValidSortFields> = {
  [TableauUserOrderField.ID]: OrderDirection.ASC,
  [TableauUserOrderField.NAME]: OrderDirection.ASC,
};


export type OwnersGridSortProviderProps = {
  readonly children: SortProviderProps<OwnersValidSortFields>['children'];
};

export function OwnersGridSortProvider(
  props: Pick<SortProviderProps<OwnersValidSortFields>, 'children'>
): JSX.Element {

  const { areUsersVisible } = React.useContext(UserAndSiteSettingsContext);
  const ownersDefaultSortField = areUsersVisible ? TableauUserOrderField.NAME : TableauUserOrderField.ID;
  const { [TableauUserOrderField.NAME]: _, ...validFieldsForHiddenUser } = OwnersDefaultDirections;
  const validFields = areUsersVisible ? OwnersDefaultDirections
    : validFieldsForHiddenUser as DefaultDirections<OwnersValidSortFields>;

  return (
    <UrlSortProvider<OwnersValidSortFields>
      validOrderFieldsWithDefaultDirections={validFields}
      defaultField={ownersDefaultSortField}
    >
      {props.children}
    </UrlSortProvider>
  );
}
